import React from 'react'
import { Grid, Typography, Button } from '@mui/material'
import PidoImage from '../../../assets/images/pido.png'
import useStyles from './styles'

function NotFound() {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Grid className={classes.gridImage}>
                <img
                    src={PidoImage}
                    alt={"pido"}
                    className={classes.image} />
            </Grid>
            <Grid className={classes.content}>
                <br />
                <Typography fontSize={20} fontWeight={450} style={{
                    boxShadow: 'rgba(0, 0, 0, 0.56) 0px 22px 70px 4px',
                    padding: 30,
                    margin: 20,
                    textAlign: 'center',
                    borderRadius: 5
                }}>
                    پیدویی عزیز ضمن تشکر از حسن انتخاب شما جهت سفارش سوخت ، نظر شما با حفظ حریم شخصی‌تان ثبت گردید.
                </Typography>
                <br />
                <Button
                    href='https://pido.co.ir'
                    variant='contained'
                >
                    {"بازگشت به سایت"}
                </Button>
                <br />
                <Button
                    variant="outlined"
                    href='tel:02191076222'
                    color="secondary"
                >
                    {"تماس با پشتیبانی"}
                </Button>
            </Grid>
        </React.Fragment >
    )
}

export default NotFound
